import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Overview from "@/components/site/Overview";
import Services from "@/components/site/Services";
import Manifesto from "@/components/site/Manifesto";
import Leadership from "@/components/site/Leadership";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-white font-body text-vg-ink" data-testid="app-root">
      <Nav />
      <main>
        <Hero />
        <Overview />
        <Services />
        <Manifesto />
        <Leadership />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
